<h1 class="se-dialog-header-warning mat-elevation-z6" mat-dialog-title>
    {{ data.title | translate }}
</h1>

<div mat-dialog-content style="padding: 20px">
    {{ data.description | translate }}
</div>

<div mat-dialog-actions style="display: flex; flex-direction: column; align-items: flex-end">
    @if (data.buttonCancel) {
        <button mat-button [mat-dialog-close]>{{ "Cancel" | translate }}</button>
    }
    @if (data.buttonOk) {
        <button mat-button color="primary" [mat-dialog-close]>{{ "Ok" | translate }}</button>
    }
</div>
